<template>
	<v-card :flat="isComponent" :outlined="isComponent">
		<v-card-title>
			<span>Usuarios</span>
			<v-subheader></v-subheader>
			<v-spacer></v-spacer>
			<!-- <user-form
				:key="`user-form-${viewConfig.formKey}`"
				:user="usuarios.seleccionado"
				:permisos="permisos.lista"
				:loadingPermisos="permisos.isloading"
				@onRefreshPermisos="getPermisos()"
				@on-success="onFormSuccess"
				@on-error="onFormError"
			/> -->
		</v-card-title>
		<v-card-text>
			<v-data-table
				:headers="headers"
				:items="usuarios.lista"
				:options.sync="usuarios.options"
				:server-items-length="usuarios.totalRecords"
				loading-text="Cargando Empresas"
				:loading="usuarios.isloading"
				:footer-props="usuarios.footer"
				no-data-text="No hemos encontrado datos..."
				sort-by="rut"
				sort-desc
				locale="es"
				:class="!isComponent?'elevation-2':''"
			>
				<!-- <template v-slot:header.es_representante="{header}">
					<v-tooltip top color="info">
						<template v-slot:activator="{ on, attrs }">
							<span v-on="on">
								{{header.text}}
								<v-icon small>help</v-icon>
							</span>
						</template>
						<span>
							Indica si el usuario es un representante legal de {{$store.getters['empresas/razon_social']}}
						</span>
					</v-tooltip>
				</template> -->
				<template v-slot:item.rut="{item, value}">
					{{ `${value}-${item.dv}` }}
				</template>
				<!-- <template v-slot:item.permisos="{item, value}">
					<gestor-permiso
						:key="`permisos-${item.usuario}`"
						:permisos="permisos.lista"
						:disabled="usuarios.isloading"
						:user="item"
						:loadingPermisos="permisos.isloading"
						@onRefreshPermisos="getPermisos()"
						@onReloadUsers="onRefresh"
					/>
				</template> -->
				<!-- <template v-slot:item.es_representante="{item, value}">
					<v-row>
						<v-spacer/>
						<v-tooltip bottom :color="value?'success': ''">
							<template v-slot:activator="{ on, attrs }">
								<v-icon 
									large 
									:color="value?'primary': ''"
									v-on="on"
								>
									{{value?'account_box': 'person'}}
								</v-icon>
							</template>
							<span>{{value?
								'Este usuario ES un representante legal de '+$store.getters['empresas/seleccionada'].razon_social:
								'Este usuario NO ES representante legal.'}}
							</span>
						</v-tooltip>
						<v-spacer/>

					</v-row>
				</template> -->

				<template v-slot:item.user="{item, value}">
					{{value|formatRut}}
				</template>
				
<!-- 				<template v-slot:item.actions="{item}">
					<v-btn
						icon
					>
						<v-icon>delete</v-icon>
					</v-btn>
					<v-btn
						icon
						@click="onEditEvt(item)"
					>
						<v-icon>edit</v-icon>
					</v-btn>
				</template> -->
			</v-data-table>
		</v-card-text>
		<v-snackbar
			v-model="alerta.display"
			:color="alerta.type"
		>
			{{ alerta.msg }}
		</v-snackbar>
	</v-card>
</template>


<script>
import GestorPermiso from '@/views/GestionUsuarios/GestorPermiso';
import GestorEmpresas from '@/views/GestionUsuarios/GestorEmpresas';
import UserForm from '@/views/GestionUsuarios/UserForm';

import { rutFormat } from 'rut-helpers';

import ApiManager from '@/views/GestionUsuarios/ApiManager';

import { mapGetters } from 'vuex';

let apiUser = new ApiManager('apiBoletaSII');

export default {
	name: 'GestionUsuarios',
	props: {
		isComponent:{
			type: Boolean,
			default: false
		}
	},
	components:{
		GestorPermiso,
		GestorEmpresas,
		UserForm
	},
	computed: {
		headers () {
			return [
				// {
				// 	text: 'RL',
				// 	value: 'es_representante',
				// 	align: 'center',
				// 	sortable: false
				// },
				{
					text: 'Nombre',
					value: 'nombre',
				},
				{
					text: 'Usuario',
					value: 'user',
				},
				// {
				// 	text: 'Permisos',
				// 	value: 'permisos',
				// 	sortable: false,
				// 	align: 'center',
				// },
				// {
				// 	text: 'Acciones',
				// 	value: 'actions',
				// 	sortable: false,
				// 	align: 'center',
				// },
			];
		},
		currentContribuyente(){
			let cont = this.$store.getters['empresas/seleccionada'];
			return !!cont ? cont.rut : null;
		}
	},
	data () {
		return {
			usuarios:{
				isloading: false,
				lista:[],
				totalRecords:0,
				options:{
					page: 1,
					sortBy: [],
					sortDesc: [],
					itemsPerPage: 10
				},
				apiCall: null,
				seleccionado:{
				},
				filtros:{
				},
				footer: {
					'items-per-page-options': [5, 10, 15, 20, 30, 50, 100, 250]
				},
			},
			permisos:{
				lista:[],
				isloading: false,
			},
			alerta:{
				display: false,
				msg: '',
				type: 'success'
			},
			viewConfig:{
				formKey:0
			}
		}
	},
	methods: {
		async getUsuarios (pag=1) {

			let vm = this;

			if( !vm.$store.getters['empresas/seleccionada'] )
				return;

			try{
				vm.usuarios.isloading = true;
				let resp = await apiUser.getCall('/gestor-get-usuarios', {
					contribuyente: vm.$store.getters['empresas/seleccionada'].rut,
					pagination: vm.usuarios.options,
					usuario: vm.$store.getters['usuario/usuario'].username
				});

				vm.usuarios.lista = resp.usuarios.results;
				vm.usuarios.totalRecords = resp.total_records;
			}catch(err){
				
			}
			vm.usuarios.isloading = false;
		},
		async getPermisos(){
			let vm = this;

			vm.permisos.lista = [];

			try{
				vm.permisos.isloading = true;
				let resp = await apiUser.getCall('/gestor-get-permisos');

				vm.permisos.lista = resp.results;
			}catch(err){
				
			}
			vm.permisos.isloading = false;
		},
		loadPage: function(page=1){
			let vm = this;
			vm.usuarios.options.page = page;
			vm.getUsuarios(page);
		},
		onEditEvt: function(user){
			this.usuarios.seleccionado=user;
		},
		onCreateNewUser: function(evt){
			
		},
		onFormSuccess: function(evt){
			this.onRefresh();
			this.showAlert(evt.type, evt.msg);
			this.usuarios.seleccionado=null;
			this.viewConfig.formKey++;
		},
		onFormError: function(evt){
			this.usuarios.seleccionado=null;
		},
		onRefresh: function(evt){
			let cPage = this.usuarios.options.page || 1;
			this.loadPage(cPage);
			this.getPermisos();
		},
		showAlert: function(type, msg){
			this.alerta.display = true;
			this.alerta.type = type;
			this.alerta.msg = msg;
		},
	},
	mounted(){

		this.getPermisos()
	},
	watch:{
		'usuarios.options': {
			deep: true,
			handler() {
				
				this.getUsuarios();
			}
		},
		currentContribuyente(val) {
			if( !val )	return;
			this.getUsuarios();
		}
	}
}
</script>

<style lang="css" scoped>
</style>